
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoySparXShape as ObiBuoySparXShapeElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-spar-x-shape.js';
 
 
 

 
 export const ObiBuoySparXShape = createComponent({
   react: React,
   tagName: 'obi-buoy-spar-x-shape',
   elementClass: ObiBuoySparXShapeElement,
   events: {
     
   }
  });
 
 